export const HORSE_TYPES = [
  { value: 'fattrice', label: 'Fattrice' },
  { value: 'puledro', label: 'Puledro' },
  { value: 'in_training', label: 'In training' },
  { value: 'monta', label: 'Monta' },
  { value: 'diritto_monta_vita', label: 'Diritto di monta a vita' },
];

export const GENDERS = [
  { value: 'Maschio', label: 'Maschio' },
  { value: 'Femmina', label: 'Femmina' },
  { value: 'Castrone', label: 'Castrone' },
];

export const AGE_RANGES = [
  { value: '0-1', label: '0–1 anno', min: 0, max: 1 },
  { value: '1-3', label: '1–3 anni', min: 1, max: 3 },
  { value: '3-6', label: '3–6 anni', min: 3, max: 6 },
  { value: '6+', label: '6+ anni', min: 6, max: 99 },
];

export const GALOPPO_LEVELS = [
  { value: 'principiante', label: 'Principiante' },
  { value: 'intermedio', label: 'Intermedio' },
  { value: 'avanzato', label: 'Avanzato' },
];

// Older horses were saved with previous labels: map them to the new categories
const LEGACY_TYPES = {
  fattrice_gravida: 'fattrice',
  stallone_da_monta: 'monta',
  stallone_monta: 'monta',
  cavallo_da_corsa: 'in_training',
  corsa: 'in_training',
};
const LEGACY_GENDERS = { stallone: 'Maschio', giumenta: 'Femmina' };

export const normalizeType = (t) => (t ? LEGACY_TYPES[t.toLowerCase()] || t : '');
export const normalizeGender = (g) => (g ? LEGACY_GENDERS[g.toLowerCase()] || g : '');
export const typeLabel = (t) => HORSE_TYPES.find(o => o.value === normalizeType(t))?.label || t || '';

// Age ranges share boundaries (1, 3, 6): an age matches every range that includes it
export const inAgeRange = (age, value) => {
  const r = AGE_RANGES.find(x => x.value === value);
  return r && age != null && age >= r.min && age <= r.max;
};

export const horseMatches = (horse, f) => {
  if (!horse) return false;
  if (f.type.length && !f.type.includes(normalizeType(horse.horse_type))) return false;
  if (f.gender.length && !f.gender.includes(normalizeGender(horse.gender))) return false;
  if (f.age.length && !f.age.some(v => inAgeRange(horse.age, v))) return false;
  if (f.galoppo.length && !f.galoppo.includes(horse.galoppo_level)) return false;
  return true;
};
